import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { ResponseStatus } from 'app/api';
import HttpStatus from 'app/components/HttpStatus';
import { Trans, useTranslation } from 'app/lang';

import notFoundImage from './images/not-found.svg';

import dictionary from './NotFound.dictionary.json';

import styles from './NotFound.module.scss';

type NotFoundProps = {
  className?: string;
};

const NotFound: FC<NotFoundProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(styles.errorTemplate, className)}>
      <img src={notFoundImage}
           width="200"
           height="200"
           className={styles.logoNotFound}
           alt={t(dictionary.title)} />
      <HttpStatus code={ResponseStatus.NOT_FOUND}>
        <div className={styles.errorDetails}>
          <h3>{t(dictionary.title)}</h3>
          <p>
            <Trans data={dictionary.description}
                   components={{
                     ref: <Link to="/" />,
                   }} />
          </p>
        </div>
      </HttpStatus>
    </div>
  );
};

export default NotFound;
